import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  titleBox: {
    // marginTop: '8px !important',
    textAlign: 'left'
  },
  icons: {
    top: theme.spacer,
    position: 'relative',
    paddingRight: theme.spacer,
  },
  contentTxt: {
    marginTop: `${theme.spacer * 5}px !important`
  },
  btnCntrls: {
    marginTop: `${theme.spacer * 6}px !important`,
  },
  contentTypography: {
    overflowY: 'scroll',
    position: 'relative',
    // height : '180px'
  },
  loader : {
      color: theme.color.notsocoolgray,
      marginLeft: 'auto',
      marginRight : 'auto',
      marginTop : '40px'
  },
  containerBox: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(0),
    
  },
  label: {
    fontWeight: 'bold',
    fontSize: '16px',
    marginBottom: theme.spacing(0.5),
    color: theme.palette.text.primary,
    backgroundColor: 'transparent', 
  },
  textBox: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
  },
}));

export default useStyles;
